var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Stack } from '@mui/material';
import { Actions, Notifications } from './components';
var View = function () {
    return (_jsxs(Stack, __assign({ justifyContent: "flex-end", alignItems: "center", height: "72px", bgcolor: "bg.light", px: 3, py: 2, direction: "row", spacing: 2 }, { children: [_jsx(Notifications, {}, void 0), _jsx(Actions, {}, void 0)] }), void 0));
};
View.displayName = 'LargeNavigation';
export default View;
